

export default () => {
  return [
    {id: "drenthe", title: "Drenthe"},
    {id: "flevoland", title: "Flevoland"},
    {id: "friesland", title: "Friesland"},
    {id: "gelderland", title: "Gelderland"},
    {id: "groningen", title: "Groningen"},
    {id: "limburg", title: "Limburg"},
    {id: "noord-brabant", title: "Noord-Brabant"},
    {id: "noord-holland", title: "Noord-Holland"},
    {id: "overijssel", title: "Overijssel"},
    {id: "utrecht", title: "Utrecht"},
    {id: "zeeland", title: "Zeeland"},
    {id: "zuid-holland", title: "Zuid-Holland"},
  ];
}